module.exports = __webpack_public_path__ + "img/growcify-business-partner-program.4cbecd2a.png";